export const CREATE_GROUP = 'playerGroups/CREATE_GROUP';
export const CREATE_GROUP_FAILURE = 'playerGroups/CREATE_GROUP_FAILURE';
export const CREATE_GROUP_SUCCESS = 'playerGroups/CREATE_GROUP_SUCCESS';

export const RESET_STATE = 'playerGroups/RESET_STATE';
